export default "__VITE_ASSET__BQVBBd9p__"